// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/NotFound.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/NotFound.tsx");
  import.meta.hot.lastModified = "1726120486084.8733";
}
// REMIX HMR END

import { useLang } from "~/utils/provider/lang-provider";
export default function NotFound() {
  _s();
  const l_labels = useLang('labels');
  return <div className="not_found">
            {l_labels('l_page_not_found')}
        </div>;
}
_s(NotFound, "5Ni8J4VOhA/irtAqhCE8Yo4/H2g=", false, function () {
  return [useLang];
});
_c = NotFound;
var _c;
$RefreshReg$(_c, "NotFound");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;